export default __webpack_public_path__ + "static/media/Yellow0001.113600a7.png";